<template>
  <div
    class="hkl-daterange"
  >
    <DatePicker
      ref="startDatePicker"
      v-bind="startDayAttrs"
      v-model="startDay"
      calendarButtonIcon="fa fa-calendar"
      @changedDay="selectedStartDay"
    />
    <slot
      name="midContentSlot"
      class="mid-content"
    />
    <DatePicker
      ref="endDatePicker"
      v-bind="endDayAttrs"
      v-model="endDay"
      calendarButtonIcon="fa fa-calendar"
      @changedDay="selectedEndDay"
    />
  </div>
</template>
<script>
import { ref, unref } from 'vue-demi'
import DatePicker from '@/controls/DatePicker'
import { triggerDatePickerValidateFusionCheck } from './utils'

export const SOURCE = 'value'
export const EVENT = 'select'

/**
 * @type {import('vue').Component}
 */
const HKLDateRange = {
  name: 'HKLDateRange',
  components: {
    DatePicker,
  },
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    [SOURCE]: {
      type: Array,
      default: () => ['', ''],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    placeholders: {
      type: Array,
      default: () => ['', ''],
    },
    displayRange: {
      type: Array,
      default: () => [],
    },
  },
  setup () {
    const startDatePicker = ref(null)
    const endDatePicker = ref(null)
    return {
      startDatePicker,
      endDatePicker,
      selectedStartDay: () => {
        triggerDatePickerValidateFusionCheck(unref(startDatePicker))
      },
      selectedEndDay: () => {
        triggerDatePickerValidateFusionCheck(unref(endDatePicker))
      },
    }
  },
  computed: {
    curDisplayRange () {
      return [
        Object.assign({ to: new Date() }, this.displayRange[0]),
        Object.assign({ from: this.startDay, to: new Date() }, this.displayRange[1]),
      ]
    },
    startDay: {
      get () {
        const val = this[SOURCE][0]
        return typeof val === 'string' && val.trim().length ? new Date(val) : val
      },
      /**
       * @type {(newDate: Date?, oldData: Date?) => any}
       */
      set (newValue) {
        const [start, end] = [
          newValue ? this.setStartDate(newValue) : newValue,
          this[SOURCE][1],
        ]
        const isDates = [start, end].map((item) => item instanceof Date)
        if (isDates.includes(false) || end >= start) {
          this.$emit(EVENT, [start, end])
        } else {
          this.$emit(EVENT, [start, start])
        }
      },
    },
    endDay: {
      get () {
        const val = this[SOURCE][1]
        return typeof val === 'string' && val.trim().length ? new Date(val) : val
      },
      /**
       * @type {(newDate: Date?, oldData: Date?) => any}
       */
      set (newValue) {
        const [start, end] = [
          this[SOURCE][0],
          newValue ? this.setEndDate(newValue) : newValue,
        ]
        const isDates = [start, end].map((item) => item instanceof Date)
        if (isDates.includes(false) || end >= start) {
          this.$emit(EVENT, [start, end])
        } else {
          this.$emit(EVENT, [end, end])
        }
      },
    },
    startDayAttrs: {
      get () {
        const attrs = this.$attrs
        const index = 0
        return Object.assign({ }, attrs, {
          calendarButton: true,
          placeholder: this.placeholders[index],
          disabledPicker: this.disabled,
          disabled: { from: this.curDisplayRange[index].to, to: this.curDisplayRange[index].from },
        })
      },
    },
    endDayAttrs: {
      get () {
        const attrs = this.$attrs
        const index = 1
        return Object.assign({ }, attrs, {
          calendarButton: true,
          placeholder: this.placeholders[index],
          disabledPicker: this.disabled,
          disabled: { from: this.curDisplayRange[index].to, to: this.curDisplayRange[index].from },
        })
      },
    },
  },
  methods: {
    setStartDate (d) {
      const date = new Date(d)
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)
      return date
    },
    setEndDate (d) {
      const date = new Date(d)
      date.setHours(23)
      date.setMinutes(59)
      date.setSeconds(59)
      date.setMilliseconds(999)
      return date
    },
  },
}

export default HKLDateRange
</script>
<style lang="scss" scoped>
.hkl-daterange {
  display: flex;
  & > .vdp-datepicker {
    width: initial;
    &:first-child {
      border-right-width: 0;
    }
  }
}
</style>
